module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-wrapper"
  }, [_c('span', [_vm._v("Options")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sharingScreenOnly),
      expression: "!sharingScreenOnly"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.videoFlipped),
      expression: "videoFlipped"
    }],
    attrs: {
      "name": "flip-video-horizontally",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.videoFlipped) ? _vm._i(_vm.videoFlipped, null) > -1 : (_vm.videoFlipped)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.videoFlipped,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.videoFlipped = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.videoFlipped = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.videoFlipped = $$c
        }
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t("button_flip_video_horizontally")) + "\n    ")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.initialMode && _vm.supportMusic),
      expression: "!initialMode && supportMusic"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.audioProcessingDisabled),
      expression: "audioProcessingDisabled"
    }],
    attrs: {
      "name": "disable-audio-processing",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.audioProcessingDisabled) ? _vm._i(_vm.audioProcessingDisabled, null) > -1 : (_vm.audioProcessingDisabled)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.audioProcessingDisabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.audioProcessingDisabled = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.audioProcessingDisabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.audioProcessingDisabled = $$c
        }
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t("button_enable_music_mode")) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e6d55de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OptionsMenuSelect.vue
// module id = 372
// module chunks = 1